<template>
  <nav class="navbar">
    <div class="flex-v__center">
      <div
        class="menu-burger display-none-desktop"
        :class="{ active: isMobileNavBar }"
        @click="isMobileNavBar = !isMobileNavBar"
      >
        <div class="menu-burger_1"></div>
        <div class="menu-burger_2"></div>
        <div class="menu-burger_3"></div>
      </div>

      <a href="/" class="logo">
        <span class="logo-icon">
          <svg width="48" height="51" viewBox="0 0 48 51" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1911_247)">
              <path
                d="M33.7262 10.2015L29.0056 20.4015L28.6643 21.1388L23.9438 31.3388V31.3402L14.844 51L10.1234 40.8L19.2218 21.1402L24.2851 10.2029V10.2015L29.0056 0.00292969L33.7262 10.2015Z"
                fill="#4DD5FF"
              />
              <path d="M47.8865 40.8L43.166 50.9986L34.0676 31.3388L38.7882 21.1388L47.8865 40.8Z" fill="#20F7C9" />
              <path
                d="M29.0056 0.00291429L24.2851 10.2015V10.2029L19.2217 21.1402L10.1234 40.8H-0.000366211L5.06151 29.8627L14.1599 10.2029L18.8819 0H29.0042L29.0056 0.00291429Z"
                fill="#3BA2FF"
              />
              <path d="M43.1659 50.9985V51H33.0421L23.9437 31.3402V31.3387H34.0675L43.1659 50.9985Z" fill="#00D89A" />
              <path d="M38.7881 21.1388L34.0675 31.3388H23.9437L28.6643 21.1388H38.7881Z" fill="#04BAA0" />
              <path d="M14.8439 51.0001H4.7201L-0.000457764 40.8H10.1233L14.8439 51.0001Z" fill="#2773FF" />
            </g>
            <defs>
              <clipPath id="clip0_1911_247">
                <rect width="48" height="51" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </span>
        <span class="logo-text">Andromo</span>
      </a>
    </div>

    <div class="navbar-box" :class="{ 'shrjak': !isMobileNavBar }">
      <ul class="main-menu">
        <li class="display-none-mobile">
          <button type="button" class="main-menu-link purple">
            {{ $t('navbar.easyStart') }}
          </button>
        </li>
        <li>
          <a href="/#/projects/" class="main-menu-link">
            {{ $t('navbar.projects') }}
          </a>
        </li>
        <!-- <li>
          <a href="/#/changelog/" class="main-menu-link">
            {{ $t('navbar.whatsNew') }}
          </a>
        </li> -->
        <language-selector @showHide="isMobileNavBar = !isMobileNavBar" />
      </ul>
    </div>

    <transition name="fade" mode="out-in">
      <div v-if="isShowBtn" class="btn-big btn-success" @click="$emit('copy')">
        {{ $t('easyStart.btn.create-an-app') }}
      </div>
    </transition>
  </nav>
</template>

<script>
import languageSelector from '@/publisher/components/languageSelector';

export default {
  name: 'menuNavBar',

  components: {
    languageSelector,
  },

  props: ['isShowBtn'],

  data: () => ({
    isMobileNavBar: false,
  }),
};
</script>
